import _ from 'lodash';
import React, { useEffect, useState, useMemo } from 'react';
import List from '@mui/material/List';
import { useLocation } from 'react-router-dom';

import { menus } from './menu';
import MenuItem from './MenuItem';
import { useSelector } from 'react-redux';

/*
const adminGroup = [
  { usrUuid: 'A36D8313-1EFE-4DC0-B212-5FE4D2BFE2FE', usrNm: '김경운' },
  { usrUuid: '54B38B51-8FCE-4301-87C3-7220A561DCA5', usrNm: '홍은주' },
  { usrUuid: 'd6d61c9c-7333-4369-b529-bbbbcb43a9d7', usrNm: '원유진' },
  { usrUuid: '157f0fc1-69f3-4a22-8b0b-05f4ed0e2e6b', usrNm: '김춘호' },
  { usrUuid: '9A64EA44-3348-4144-B796-6C6537581E65', usrNm: '박형석' },
  { usrUuid: 'e3e1a566-0e65-11ec-b577-f220cd7628ac', usrNm: 'admin' },  
];
*/
const MenuList = ({handleDrawerClose}) => {
  const { user } = useSelector(({ auth }) => ({
    user: auth.user,
  }));
  
  const { pathname } = useLocation();

  const userMenu = menus
  .filter(menu => !menu.admin)
  .map(menu => ({
    ...menu,
    items: menu.items ? menu.items.filter(item => !item.admin) : []
  }));

  const [filterMenus, setFilterMenus] = useState(userMenu);

  useEffect(() => {
    if (user) {
      /*
      const findIndex = _.findIndex(adminGroup, function (g) {
        return g.usrUuid === user.usrUuid;
      });

      if (findIndex > -1) {
        setFilterMenus(menus);
      }
      */
     if(user.adminRole === 'Y') setFilterMenus(menus);
    }
  }, [user]);

  const activeMenus = useMemo(() => {
    return filterMenus.map(menu => {
      // includes 대신 정확한 경로 매칭을 사용하여 중복 활성화 방지
      const isOpen = menu.items?.some(item => {
        const itemPath = `/${item.link}`;
        
        // 1. 경로가 완전히 일치하거나
        // 2. 하위 경로(/detail 등)가 있는 경우 상위 메뉴도 열려있게 하려면 
        // 해당 대분류 하위의 depth를 체크하는 로직이 필요할 수 있습니다.
        // 현재는 '정확히 일치'를 우선 적용합니다.
        return pathname === itemPath || pathname.startsWith(`${itemPath}/`);
      });

      return {
        ...menu,
        defaultOpen: isOpen
      };
    });
  }, [filterMenus, pathname]);
  // -------------------------------------------------------

  return (
    <List
      sx={{ width: '100%', bgcolor: '#fafafa', color: '#424242' }}
      component="nav"
    >
      {activeMenus.map((menu, index) => {
        return (
          <MenuItem 
            handleDrawerClose={handleDrawerClose} 
            menu={menu} 
            key={index} 
            defaultOpen={menu.defaultOpen} 
          />
        );
      })}
    </List>
  );
};

export default MenuList;
